module.exports = __webpack_public_path__ + "img/fail.924f1150.png";